import { render, staticRenderFns } from "./RoomExtension.vue?vue&type=template&id=3db253f0"
import script from "./RoomExtension.vue?vue&type=script&lang=js"
export * from "./RoomExtension.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports